<template>
  <div class="ls">
    <div class="top">
      <div class="center">
         <div class="logo">
          <router-link to="/">1K Medicinal Plant Genome Database</router-link>
        </div>
        <div class="user"></div>

        <el-menu class="el-menu-demo" mode="horizontal">
          <el-menu-item index="1">
            <router-link to="/register">Register</router-link>
          </el-menu-item>
          <el-menu-item index="2">
            <router-link to="/login">Login</router-link>
          </el-menu-item>
          <el-menu-item index="3">
            <router-link to="/contactus">Contact us</router-link>
          </el-menu-item>
          <el-menu-item index="4"><router-link to="/vipServer">Membership service</router-link></el-menu-item>
        </el-menu>
      </div>
    </div>
    <!-- <div class="menu">
      <div class="content1">
        <div class="logo"><router-link to="/">千种药用植物基因组数据库</router-link></div>
        <div class="btn">
          <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1">Blast</el-menu-item>
            <el-menu-item index="2">Primer design</el-menu-item>
          </el-menu>
        </div>
      </div>
    </div> -->
    <div class="line"></div>
    <div class="content">
    <div class="register">
      <div class="left">
        <div class="title">Register</div>
        <div class="from">
          <div class="row">
            <div class="reg"><span class="red"> * </span>User name：</div>
            <el-input
              v-model="username"
              placeholder="Use 2-14 characters"
              class="myinput"
            ></el-input>
          </div>
          <div class="row">
            <div class="reg"><span class="red"> * </span>Name：</div>
            <el-input
              v-model="realname"
              placeholder="Your real name"
              class="myinput"
            ></el-input>
          </div>
          <div class="row">
            <div class="reg"><span class="red"> * </span>E-mail：</div>
            <el-input
              v-model="email"
              placeholder="Frequently used email address"
              class="myinput"
            ></el-input>
          </div>
          <div class="row">
            <div class="reg"><span class="red"> * </span>Password：</div>
            <el-input
              v-model="password"
              placeholder="Use 5 or more characters"
              class="myinput"
              show-password
            ></el-input>
          </div>
          <div class="row">
            <div class="reg"><span class="red"> * </span>Confirm password：</div>
            <el-input
              v-model="repassword"
              placeholder="Retype Password"
              class="myinput"
              show-password
            ></el-input>
          </div>
          <div class="row">
            <div class="reg"><span class="red"> * </span>Telephone：</div>
            <el-input
              v-model="telephone"
              placeholder="Your telephone number"
              class="myinput"
            ></el-input>
          </div>
          <div class="row">
            <div class="reg"><span class="w"></span>Research interests：</div>
            <el-input
              v-model="direction"
              placeholder="Research Interests"
              class="myinput"
            ></el-input>
          </div>
          <div class="row">
            <div class="reg"><span class="red"> * </span>The institutions：</div>
            <el-input
              v-model="college"
              placeholder="Your institution"
              class="myinput"
            ></el-input>
          </div>

          <div class="link">
            <a>Fields with * are required</a>
          </div>
          <el-button plain class="btnregister" @click="register"
            >Register</el-button
          >
        </div>
      </div>
      <div class="line"></div>
      <div class="right">
        <div class="title">Database Introduction</div>
        <p>
          1K Medicinal Plant Genome Research Project aims to complete the
          collection and sequencing of 1000 important medicinal plant
          genomes within 3-5 years, and builds the world's largest database
          of medicinal plant genomes. The database collects genomic data and
          related information of related medicinal plants, aiming to promote
          the research of genomics, secondary metabolite synthesis biology
          and related molecular breeding of medicinal plants.
        </p>
      </div>
    </div>
  </div>

   <div class="footer">Copyright © 2018 Wuhan Benagen Tech Solutions Company Limited. <span class="mlm"><a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备2021008976号-1</a></span></div>
  </div>
</template>

<script>
import axios from "axios";
import {isEmail} from "../utils/utils";

export default {
  data() {
    return {
      college: "",
      direction: "",
      email: "",
      password: "",
      repassword: "",
      realname: "",
      telephone: "",
      username: "",
    };
  },
  methods: {
    register() {
      if (this.username == "" || this.username == null) {
        this.$message.error({
          message: "Notice: please enter your user name！",
          offset: 300,
        });
        return false;
      }
      if (this.username.length < 2 || this.username.length > 14) {
        this.$message.error({
          message: "Notice, Use 2-14 characters！",
          offset: 300,
        });
        return false;
      }
      if (this.realname == "" || this.realname == null) {
        this.$message.error({
          message: "Notice, Your real name！",
          offset: 300,
        });
        return false;
      }
      if (this.email == "" || this.email == null) {
        this.$message.error({
          message: "Notice, Frequently used email address！",
          offset: 300,
        });
        return false;
      } else {
          if(!isEmail(this.email)) {
              this.$message.error({
                  message: "Notice, please enter correct e-mail！",
                  offset: 300,
              });
              return false;
          }
      }

      if (this.password == "" || this.password == null) {
        this.$message.error({
          message: "Notice: please enter your password！",
          offset: 300,
        });
        return false;
      }
      if (this.password.length < 5 || this.password.length > 20) {
        this.$message.error({
          message: "Notice: please enter your password！",
          offset: 300,
        });
        return false;
      }
      if (this.repassword == "" || this.repassword == null) {
        this.$message.error({
          message: "Notice: please enter your password again！",
          offset: 300,
        });
        return false;
      }
      if (this.repassword != this.password) {
        this.$message.error({
          message: "Notice: please check whether the login passwords entered twice are the same！",
          offset: 300,
        });
        return false;
      }
      if (this.telephone == "" || this.telephone == null) {
        this.$message.error({
          message: "Notice: please enter your telephone number！",
          offset: 300,
        });
        return false;
      }
      if (this.college == "" || this.college == null) {
        this.$message.error({
          message: "Notice: please enter your institution name！",
          offset: 300,
        });
        return false;
      }
      let data = {
        college: this.college,
        direction: this.direction,
        email: this.email,
        password: this.password,
        repassword: this.repassword,
        realname: this.realname,
        telephone: this.telephone,
        username: this.username,
        reday: 0,
        state: 1,
        user_id: 0,
      };
      let that = this;
      axios
        .post("/bena/server/gooal/user/register", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          ////console.log(response);
          if (response.data.code == 0) {
            //ok
            that.$alert("Registration successful！", "Notice", {
              confirmButtonText: "Confirm",
              callback: (action) => {
                that.$router.push("/login");
              },
            });
          }else{
            that.$alert("Registration failed！"+response.data.msg, "Notice", {
              confirmButtonText: "Confirm",
              callback: (action) => {
                //that.$router.push("/login");
              },
            });
          }

        })
        .catch(function (error) {
          that.$message.error("Registration failed!");
          //console.log(error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ls{
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.el-menu-demo.el-menu--horizontal.el-menu .el-menu-item:hover {
  color: seagreen;
}
.el-menu-demo.el-menu--horizontal.el-menu .el-menu-item a {
  text-decoration: none;
}
.top {
  width: 100%;
  height: 70px;
  background: seagreen;
  border-bottom: solid 1px #e6e6e6;
  flex: 0;
}
.top .center {
  width: 1200px;
  height: 70px;
  margin: 0 auto;
  display: flex;
}
.top .center .el-menu-demo {
  width: 476px;
}
.top .center .user {
  flex: 1;
  /* border: 1px solid red; */
  line-height: 70px;
  color: #fff;
  font-size: 14px;
  text-align: right;
}
.top .center .user .mglm {
  margin-left: 10px;
  color: #fff;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}
.el-dropdown-menu.el-popper .el-dropdown-menu__item:hover {
  color: seagreen;
}
.top .center .el-menu-demo.el-menu--horizontal.el-menu {
  background: seagreen;
}
.top .center .el-menu.el-menu--horizontal {
  border: none;
}
.top .center .el-menu--horizontal > .el-menu-item {
  height: 70px;
  line-height: 70px;
  color: #fff;
}
.top .center  .logo {
  line-height: 70px;

  float: left;
}
.top .center  .logo a {
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
}
.menu .content1 {
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .content1 .logo {
  float: left;
  width: 200px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 60px;
  text-align: center;
}
.menu .content1 .logo a{
  color: #000;
  text-decoration: none;
}
.menu .content1 .btn {
  float: right;
  width: auto;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.line {
  width: 100%;
  height: 10px;
  background: #eee;
  flex: 0;
}

.footer {
  width: 100%;
  height: 45px;
  background: seagreen;
  font-size: 12px;
  text-align: center;
  line-height: 45px;
  color: #fff;
  flex: 0;
}
.el-button.btnregister.el-button--default.is-plain:hover {
  border: seagreen 1px solid;
  color: seagreen;
}
.content {
  background: #eee;
  width: 100%;
  /* overflow: auto; */
  flex: 1;
}
.content .register {
  width: 720px;
  height: 500px;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 2px #ccc;
  margin: 20px auto;
  background: #fff;
  padding: 30px 40px;
}
.register .left {
  float: left;
  height: 500px;
  width: 360px;
}
.register .line {
  width: 1px;
  background: #eee;
  height: 500px;
  float: left;
}
.register .right {
  float: left;
  height: 500px;
  width: 309px;
  padding: 0 20px 0 30px;
}
.register .right p {
  font-size: 12px;
  line-height: 25px;
  color: #aaa;
}
.register .left .title {
  color: seagreen;
  font-size: 18px;
}
.register .right .title {
  color: seagreen;
  font-size: 18px;
}
.register .left .from {
  width: 97%;
  height: auto;
}
.from .row {
  display: flex;
}
.from .row .myinput {
  margin-bottom: 10px;
  flex: 1;
}
.from .row .reg {
  width: 150px;
  font-size: 13px;
  line-height: 35px;
  color: rgb(12, 11, 11);
}
.from .row .reg .red {
  color: red;
}
.from .row .reg .w {
  display: block;
  width: 10px;
  height: 35px;
  float: left;
}
.from >>> .el-input__inner {
  border-radius: 0;
  height: 35px;
  font-size: 12px;
}
.register .left .from .pwd {
  margin-top: 20px;
}
.register .left .from .link {
  margin: 10px 0 20px 0;
}
.register .left .from .link a {
  color: seagreen;
  text-decoration: none;
  font-size: 12px;
}
.btnregister {
  width: 100%;
  height: 35px;
  background: seagreen;
  color: #fff;
  line-height: 10px;
  border-radius: 0;
}
.footer a{
  color: unset;
  text-decoration: none;
}
</style>
